import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import { useMutation } from 'react-query';

import useAxios from 'src/api/useAxios';
import { toast } from 'react-toastify';

const ConfirmModal = ({
    isOpen,
    toggle,
    guest,
    refetch,
    toggleEditModal
    }) => {

  let api = useAxios();

  const deleteStop = (payload) => {
    return api.delete(`/guests/stop/${guest}`)
  }

  const deleteStopMutation = useMutation(deleteStop, {
    onSuccess: (res) => {
      toast.success('Deleted')
      toggle()
      refetch()
      toggleEditModal()
    },
    onError: (res) => {
      toast.error('Something went wrong')
    }
  })

  return (
    <Modal isOpen={isOpen} toggle={toggle} className='modal-md'>
      <ModalHeader toggle={toggle}>
        <h4 className='text-primary mb-0'>Delete Stop</h4>
      </ModalHeader>
      <ModalBody>
          <div className='row py-3'>
              <h6>Are you sure you want to delete the stop?</h6>
          </div>  

      </ModalBody>
      <ModalFooter>
        {
          deleteStopMutation.isLoading ? 
          <p>Processing...</p>
          :
          <>
            <button onClick={toggle} type="button" className="btn admin-gray-btn">
          No
        </button>
        <button onClick={() => deleteStopMutation.mutate()} type="submit" className="btn admin-green-btn">
          Yes
        </button>
  </>
        }
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
